var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.76172 11.5204V16.4904C4.76172 18.3104 4.76172 18.3104 6.48172 19.4704L11.2117 22.2004C11.9217 22.6104 13.0817 22.6104 13.7917 22.2004L18.5217 19.4704C20.2417 18.3104 20.2417 18.3104 20.2417 16.4904V11.5204C20.2417 9.70043 20.2417 9.70043 18.5217 8.54043L13.7917 5.81043C13.0817 5.40043 11.9217 5.40043 11.2117 5.81043L6.48172 8.54043C4.76172 9.70043 4.76172 9.70043 4.76172 11.5204Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.13V5.5C18 3.5 17 2.5 15 2.5H10C8 2.5 7 3.5 7 5.5V8.06",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1317 11.49L13.7017 12.38C13.7917 12.52 13.9917 12.66 14.1417 12.7L15.1617 12.96C15.7917 13.12 15.9617 13.66 15.5517 14.16L14.8817 14.97C14.7817 15.1 14.7017 15.33 14.7117 15.49L14.7717 16.54C14.8117 17.19 14.3517 17.52 13.7517 17.28L12.7717 16.89C12.6217 16.83 12.3717 16.83 12.2217 16.89L11.2417 17.28C10.6417 17.52 10.1817 17.18 10.2217 16.54L10.2817 15.49C10.2917 15.33 10.2117 15.09 10.1117 14.97L9.44173 14.16C9.03173 13.66 9.20173 13.12 9.83173 12.96L10.8517 12.7C11.0117 12.66 11.2117 12.51 11.2917 12.38L11.8617 11.49C12.2217 10.95 12.7817 10.95 13.1317 11.49Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.cde27a1eebc8893066cc37f3b69ddef9.svg";
export { ForwardRef as ReactComponent };